export default {
  // Page title
  'page.title': 'Секундомер',

  // How to use
  'howto.title': 'Как Использовать',
  'howto.step1': 'Нажмите кнопку "Старт", чтобы запустить секундомер, формат отображения: минуты:секунды.сотые доли секунды',
  'howto.step2': 'Нажмите "Пауза", чтобы приостановить отсчет времени, когда секундомер работает, нажмите "Старт" снова, чтобы продолжить',
  'howto.step3': 'Нажмите кнопку "Сброс", чтобы сбросить секундомер на ноль и остановить отсчет',
  'howto.step4': 'Секундомер поддерживает отображение с точностью до миллисекунды, подходит для сценариев, требующих точного хронометража',

  // User reviews
  'reviews.title': 'Отзывы Пользователей',
  'reviews.michaelRunner': 'Незаменимый инструмент для тренировок! Точность до миллисекунды позволяет мне точно записывать каждый результат спринта, простая и быстрая работа.',
  'reviews.chefJohnson': 'Волшебство таймера для кухни! Обжаривание, варка лапши, приготовление яиц на пару - всё требует точного хронометража, этот секундомер помогает мне готовить идеальные блюда.',
  'reviews.sarahStudent': 'Необходим для симуляции экзаменов! Использую для практики времени ответов, чистый интерфейс не отвлекает внимание, повысил эффективность ответов.',
  'reviews.coachWilliams': 'Отличный помощник для тренировочных занятий! Интервальные тренировки и планки требуют точного хронометража, студенты в восторге.',
  'reviews.drAnderson': 'Медицинская работа часто требует точного хронометража, этот секундомер прост и надежен, отличный помощник для моей клинической работы.',

  // User names
  'user.michaelRunner': 'Майкл Бегун',
  'user.chefJohnson': 'Шеф-повар Джонсон',
  'user.sarahStudent': 'Сара Студентка',
  'user.coachWilliams': 'Тренер Уильямс',
  'user.drAnderson': 'Доктор Андерсон',

  // Keywords section
  'keywords.stopwatch': 'секундомер таймер точный хронометраж который час',
  'keywords.chinese': '秒表 计时器 精确计时 现在几点',
  'keywords.japanese': 'ストップウォッチ タイマー 精密計時 今何時',
  'keywords.spanish': 'cronómetro temporizador tiempo preciso qué hora',
  'keywords.german': 'Stoppuhr Timer präzise Zeit wie spät',
  'keywords.french': 'chronomètre minuteur temps précis quelle heure',
  'keywords.russian': 'секундомер таймер точное время который час',
};